// Lightweight Web Audio sound effects. No external files needed.

let ctx = null;
let muted = false;

function ac() {
  if (typeof window === 'undefined') return null;
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    ctx = new AC();
  }
  if (ctx.state === 'suspended') ctx.resume();
  return ctx;
}

export function unlockAudio() {
  ac();
}

export function setMuted(m) {
  muted = m;
}

function tone(freq, start, dur, { type = 'sine', gain = 0.18 } = {}) {
  const c = ac();
  if (!c || muted) return;
  const osc = c.createOscillator();
  const g = c.createGain();
  osc.type = type;
  osc.frequency.setValueAtTime(freq, c.currentTime + start);
  g.gain.setValueAtTime(0.0001, c.currentTime + start);
  g.gain.exponentialRampToValueAtTime(gain, c.currentTime + start + 0.02);
  g.gain.exponentialRampToValueAtTime(0.0001, c.currentTime + start + dur);
  osc.connect(g);
  g.connect(c.destination);
  osc.start(c.currentTime + start);
  osc.stop(c.currentTime + start + dur + 0.02);
}

export function playTap() {
  tone(520, 0, 0.09, { type: 'triangle', gain: 0.12 });
}

export function playCorrect() {
  tone(523, 0, 0.14, { type: 'triangle' });
  tone(659, 0.1, 0.14, { type: 'triangle' });
  tone(784, 0.2, 0.2, { type: 'triangle' });
}

export function playWrong() {
  tone(300, 0, 0.16, { type: 'sawtooth', gain: 0.12 });
  tone(220, 0.14, 0.22, { type: 'sawtooth', gain: 0.12 });
}

export function playStar() {
  tone(880, 0, 0.08, { type: 'sine', gain: 0.1 });
  tone(1174, 0.07, 0.1, { type: 'sine', gain: 0.1 });
}

export function playCelebrate() {
  const notes = [523, 659, 784, 1046, 784, 1046, 1318];
  notes.forEach((f, i) => tone(f, i * 0.13, 0.2, { type: 'triangle', gain: 0.16 }));
}

// A short cheerful note used to keep a musical rhythm during the lesson
export function playBlip(step) {
  const scale = [392, 440, 494, 523, 587, 659, 698, 784, 880, 988];
  tone(scale[step % scale.length], 0, 0.12, { type: 'triangle', gain: 0.1 });
}
